import { PageRowsResponseDTO } from './page-response-dto';
import { UserApproverRoleDTO } from './user-approver-role-dto';

export interface ReadContextResponseDTO extends PageRowsResponseDTO<UserApproverRoleDTO> {
    userRoles?: UserApproverRoleDTO[];
}
